import React from 'react';
import { tryDark, workAtDark } from "../../Markup"

const team = [
  {
    name: "Ellen",
    title: "Co-founder & CEO",
    img: "ellen",
    pronoun: "She/Her"
  },
  {
    name: "Paul",
    title: "Co-founder & CTO",
    img: "paul",
    pronoun: "He/Him"
  },
  {
    name: "Ian C",
    title: "Engineer",
    img: "ianC",
    pronoun: "He/Him"
  },
  {
    name: "Alice",
    title: "Designer",
    img: "alice",
    pronoun: "She/Her"
  },
  {
    name: "Ian S",
    title: "Engineer",
    img: "ianS",
    pronoun: "He/They"
  },
  {
    name: "Sydney",
    title: "Engineer",
    img: "sydney",
    pronoun: "She/Her"
  },
  {
    name: "Korede",
    title: "Engineer",
    img: "korede",
    pronoun: "He/Him"
  },
  {
    name: "Julian",
    title: "Engineer",
    img: "julian",
    pronoun: "He/Him"
  },
  {
    name: "Dean",
    title: "Engineer",
    img: "dean",
    pronoun: "He/Him"
  },
  {
    name: "Victoria",
    title: "Chief of Staff",
    img: "victoria",
    pronoun: "She/Her"
  },
  {
    name: "Jessica",
    title: "Support Engineer",
    img: "jessica",
    pronoun: "They/Them"
  }
]

const investors = {
  title: "Our Investors & Advisors",
  subtext: [
    {
      class: "medium-title center-text",
      text: "Our seed round was led by Cervin Venture with participation from Boldstart, Data Collective," +
        " Harrision Metal, XFactor, Backstage, Nextview, Promus, Correlation, 122 West, and Yubari."
    },
    {
      class: "purple medium-title center-text",
      text: "We've also been lucky to have a great set of angel investors who have provided guidance and feedback, and support, including:"
    }
  ],
  investors: [
    "James Tamplin",
    "Eric Ries",
    "Edith Harbaugh",
    "Erica Brescia",
    "Greg Brockman",
    "Andrew Miklas",
    "David Eckstein",
    "Christina Cacioppo",
    "Steve Krouse",
    "Paul English",
    "Pete Koomen",
    "Hiten Shah",
    "Nitesh Banta",
    "Phillip Bond",
    "Darragh Buckley",
    "Albert Ni",
    "Sam Stokes",
    "Russ Smith",
    "Bryan Jowers",
    "David Chang",
    "Jean-Denis Greze",
    "Kyle Wild",
    "Thomson Nguyen",
    "Mathew Johnson",
    "Teck Chia",
    "Lucas Nealan",
    "Dave Concannon",
    "Brendan Ciecko",
    "Elizabeth Dobrska",
    "Brad Flora",
    "Jon Dahl",
    "Shalini Agarwal",
    "Sheel Mohnot",
    "John McGugan",
    "Jon Scherr",
    "Jonathan Siegel",
    { name: "Ed Roman", subName: "(AngelList Syndicate)" }
  ],
  contributorTitle: "Past Contributors",
  pastContributors: ["Stefi Petit", "Audrey Anderson"] //"Korede Aderele"
}

const aboutPageData = [
  {

    type: "Center",
    id: "values",
    class: "short white-background",
    title: { text: "Values", class: "large-title medium-purple" },
    paragraph: [
      {
        class: "small-title center-text mankSans",
        text: "We want this to be the best job we've had, and the best job you've had. This means doing the work that matters, in a way that aligns with our values. These values are a guiding light on how we decide what to work on, and how we work."

      },
    ],
    centerAction: null
  },
  {
    type: "LeftAlignTwoColumn",
    class: "grey-sideline",
    columns: [
      {
        title: {
          class: "medium-purple align-right mankSans",
          text: "Impactful",
        },
        paragraph: {
          class: "paragraph-text mankSans",
          text: "We have a big mission, and to get there, we need to do things that matter. We even hired a customer to make sure we remained focused. We’re completely reimagining how we write software.",
        },
        link: null
      },
      {
        title: {
          class: "medium-purple align-right mankSans",
          text: "Decisive",
        },
        paragraph: {
          class: "paragraph-text mankSans",
          text: "We err on the side of decentralized decision making, and we don’t interrupt each other on vacation. We work on something we know is important, rather than waiting for someone else to assign a task. When we make a mistake, we fix it thoughtfully.",
        },
        link: null
      },
      {
        title: {
          class: "medium-purple align-right mankSans",
          text: "Collaborative",
        },
        paragraph: {
          class: "paragraph-text mankSans",
          text: "We’re a company that is made of people, not just employees. We care about transparency and collective accountability. We want to provide space for you to be your authentic self at and bring your unique perspective to work.",
        },
        link: null
      },
      {
        title: {
          class: "medium-purple align-right mankSans",
          text: "Introspective",
        },
        paragraph: {
          class: "paragraph-text mankSans",
          text: "We aren’t perfect, and the company isn’t either. We surface mistakes and reflect on them honestly. Incremental changes add up, so we constantly work to make ourselves better."
        },
        link: null
      },
    ]
  },
  {
    type: "Center",
    class: "short dark-purple-background",
    title: { text: "Key:values profile", class: "large-title light-purple" },
    paragraph: [
      {
        class: "small-title white-text center-text mankSans",
        text: [<div>Want to see examples of how we incorporate these into our work? <a className={"light-purple"} target={"_blank"} rel="noopener noreferrer" href={"https://keyvalues.com/dark"}>Check out our key:values profile.</a></div>]
      },
    ],
  },
]

const aboutPageBottomData = [
  workAtDark,
  tryDark
]

export { aboutPageData, aboutPageBottomData, investors, team }
